// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"1b87a3a7","197":"300cd434","622":"a0c100ce","724":"037a9ae7","992":"116df0b9"}[chunkId] + ".chunk.js";
};